<style>
</style>

<template>

  <div class="modal-backdrop">
    <div class="modal dark-panel mt-5" style="height:95%;">
      <header class="modal-header">
        <slot name="header">
          <h1>{{trans.get('common.importplan.title')}}</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>

      <section class="modal-body">
        <slot name="body">
            <form id="formImportPlan" method='post' enctype='multipart/form-data' :action="routesubmit">
                <input type="hidden" name="_token" v-bind:value="csrf">
                <div class="row">
                    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                        <div id="mapModalImport" class="min-h-70"><div class="menu"></div></div>
                    </div>
                    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                        <!-- colonne des champs -->
                        <div class="mb-5 text-left">
                            <div class="row">
                                <!-- Champ de sélection du fichier de l'image -->   
                                <div class="col-md-4">
                                    <h6>{{trans.get('common.importplan.fileimport')}}</h6>
                                </div>
                                <div class="col-md-5 input-group-text">
                                    <input id="inputImg" type="file" accept="image/*" name="inputImg" @change="readURL(this)" />
                                </div>
                            </div>
                        </div>
                        <div v-if="imageSelected">
                            <div class="mb-3 text-left">
                                <div class="row mb-2">
                                    <!-- Taille image -->
                                    <div>
                                        <h5>{{trans.get('common.importplan.sliders.title')}}</h5>
                                    </div>
                                </div>
                                <!-- Champs de mise à l'échelle -->
                                <div class="row mb-2">
                                    <!-- Taille image -->
                                    <div class="col-md-4">
                                        <h6>{{trans.get('common.importplan.sliders.size')}}</h6>
                                    </div>
                                    <div class="col-md-5">
                                        <input type="range" min="0" max="200" step="0.1" id="sizeslider" v-model="size" class="w-100" @change="updateSize">
                                    </div>
                                    <div class="col-md-2">
                                        <input type="number" min="0" max="200" step="0.1" v-model="size" id="valSize" @change="updateSize" class="form-control"/>
                                    </div>
                                    <div class="col-md-1">
                                        <h6>%</h6>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <!-- Décalage par rapport à la gauche -->
                                    <div class="col-md-4">
                                        <h6>{{trans.get('common.importplan.sliders.offsetx')}}</h6>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="range" min="0" max="500"  id="offsetsideslider" v-model="offsetx" class="w-100" @change="updateOffsetX">
                                    </div>
                                    <div class="col-md-2">
                                        <h6 id="valOffsetX">{{offsetx}} px</h6>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <!-- Décalage par rapport au haut -->
                                    <div class="col-md-4">
                                        <h6>{{trans.get('common.importplan.sliders.offsety')}}</h6>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="range" min="0" max="500"  id="offsettopslider" v-model="offsety" class="w-100" @change="updateOffsetY">
                                    </div>
                                    <div class="col-md-2">
                                        <h6 id="valOffsetY">{{offsety}} px</h6>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <!-- Rotation -->
                                    <div class="col-md-4">
                                        <h6>{{trans.get('common.importplan.sliders.rotation')}}</h6>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="range" min="-180" max="270" id="rotationslider" v-model="rotation" class="w-100" @change="updateRotation">
                                    </div>
                                    <div class="col-md-2">
                                        <h6 id="valRotation">{{rotation}} deg</h6>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <!-- Rotation -->
                                    <div class="col-md-4">
                                        <h6>{{trans.get('common.importplan.sliders.transparency')}}</h6>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="range" min="0" max="100" id="transparencyslider" v-model="transparency" class="w-100" @change="updateTransparency">
                                    </div>
                                    <div class="col-md-2">
                                        <h6 id="valRotation">{{transparency}} %</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 mx-0 text-center">
                                <input name="data" type="hidden" id="data" style="visibility:hidden" >
                                <div class="col-md-6 col-lg-6" style="margin-left: auto; margin-right: auto;">
                                    <button type="button" class="buttonOriginal" v-on:click="save()" :title="trans.get('common.save')">
                                        <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                                    </button>
                                    <h6>{{trans.get('common.save')}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </slot>
       </section>

      <footer class="modal-footer">
        <button type="button" class="btn btn-primary text-blue_claire" @click="close">
          {{trans.get('common.cancel')}}
        </button>
      </footer>
    </div>
  </div>
</template>


<script>
    export default {
        name: "importPlanModal",
        props : ['zone', "name", 'appurl', 'show', 'routesubmit'],     
        data : function(){
            return {
                map : {},
                longitude: 0,
                latitude: 0,
                width: 100,
                height: 100,
                size: 100,
                offsetx: 150,
                offsety: 150,
                rotation: 0,
                transparency: 0,
                idZone:"",
                noms:"",
                overlay: {},
                menuRegle: {},
                imageBaseWidth: 0,
                imageBaseHeight: 0,
                imageSelected: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            };
        },
        mounted: function(){
            const zoneparsed = JSON.parse(this.zone);
            this.longitude = zoneparsed.longitude;
            this.latitude = zoneparsed.latitude;
            this.idZone=zoneparsed.id;
            this.type =zoneparsed.name;
            this.noms =this.name;
            
            const token = process.env.MIX_GOOGLE_MAP_KEY;
            const GoogleMap = require("@googlemaps/js-api-loader");

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries: ["drawing","geometry"]
            });

            loader.load().then(() => {
                // Initiate map
                this.map = new google.maps.Map(document.querySelector("#mapModalImport"), {
                    center: { lat: this.latitude, lng: this.longitude },
                    zoom: 19,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    scaleControl: true, // affiche l'echelle
                    heading: 0,
                    tilt: 0,
                    mapId: "90f87356969d889c",
                });

                var zoomRangeModifier = this.map.__proto__.__proto__.__proto__;
                var originalSetFunc = zoomRangeModifier.set;
                var hijackedSetFunc = function(name, value) {
                    if (name === 'maxZoom') {
                        value = 21;
                    }
                    originalSetFunc.call(this, name, value);
                };
                zoomRangeModifier.set = hijackedSetFunc;


                // Initiate base marker
                const siteMarker = new google.maps.Marker({
                    position: { lng: this.longitude, lat: this.latitude },
                    map: this.map,
                    draggable: false,
                    label: {
                        color: "white",
                        fontWeight: "bold",
                        text: "Site",
                    },
                    icon: {
                        url: "/image/maps/marker_blue.png",
                        labelOrigin: new google.maps.Point(11, 50),
                        size: new google.maps.Size(25, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(11, 40),
                    },
                });

                const AddImagePlanOverlay = require("../addImagePlanOverlay.js");

                let image ="";
                this.overlay = new AddImagePlanOverlay.default(this.map, image, "imagePlanImg", this.width, this.height, this.offsetx, this.offsety, this.rotation);

                this.overlay.setMap(this.map);
                this.overlay.hide();

                const menu = document.createElement("div");
                menu.className = "menu menu-right";

                const Regle = require("../regle.js");
                this.menuRegle = new Regle.default(this.map);
                menu.appendChild(this.menuRegle.getItemMenu());
                this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(menu);
            });
        },
        methods :{
            close() {
                this.$emit('close');
            },
            updateSize() {
                this.width = this.size * this.imageBaseWidth / 100;
                this.height = this.size * this.imageBaseHeight / 100;
                this.overlay.updateSize(this.width, this.height);
            },
            updateRotation() {
                this.overlay.applyRotation(this.rotation);
            },
            updateOffsetX() {
                this.overlay.updateOffsetX(parseInt(this.offsetx));
            },
            updateOffsetY() {
                this.overlay.updateOffsetY(parseInt(this.offsety));
            },
            updateTransparency() {
                this.overlay.updateTransparency((100-parseInt(this.transparency))/100);
            },
            save(){
                //var data_array =[];
                let center = this.map.getCenter();
                let sw = this.overlay.getSouthWestPos();
                let ne = this.overlay.getNorthEastPos();
                var data_to_save = {
                    rotationAngle: this.rotation,
                    sw: sw,
                    ne: ne
                };
                document.getElementById('data').value = JSON.stringify(data_to_save);
                document.getElementById("formImportPlan").submit();
            },
            readURL(input) {
                var file = document.getElementById('inputImg').files[0];
                var srcImage = "";
                if (file) {
                    srcImage = window.URL.createObjectURL(file);
                    this.imageSelected = true;
                } else {
                    this.imageSelected = false;
                }
                this.overlay.updateImage(srcImage).then((result) => {
                    this.overlay.updateVisibility();
                    this.imageBaseHeight = document.getElementById("imagePlanImg").clientHeight;
                    this.imageBaseWidth = document.getElementById("imagePlanImg").clientWidth;
                    this.size = 80;
                    this.updateSize();
                });
            },
        }
    }

</script>
<style>
.button-control {
    background-color: white;
    margin: 5px;
}

.button-control > button {
    height: 24px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% padding-box;
    padding: 3px 4px 4px 4px;
}

.control-left {
    font-size: 20px;
}

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
  }

  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 85%;
    margin-left: 7.5%;
    padding: 3rem;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>